import { http } from "./httpServices";
import { CARDS, GENERATE_PHYSICAL_CARDS } from "./constants";

export function getCardQR() {
  let data = { count: 1 };
  return http.post(GENERATE_PHYSICAL_CARDS, data);
}

export function getCardList(activePage: number, limitCount: number) {
  return http.get(`${CARDS}?page=${activePage}&limit=${limitCount}`);
}
